import defaultCloudPrices from "../../prices/constants/defaultCloudPrices";

import agreementParts from "./agreementParts";
import agreementTypes from "./agreementTypes";

// The defaults for a new cloud agreement.
const cloudAgreementSkeleton = {
	name: "Cloud storage and distribution",
	type: agreementTypes.CLOUD,
	part: agreementParts.PUBLISHER,
	life: 365,
	prices: Object.values(defaultCloudPrices).map((price) => ({ ...price, approved: false, maxUses: false })),
};

export default cloudAgreementSkeleton;
